import { Component } from '@angular/core';
import { ProceedService } from '@modules/booking/services';
import { Store } from '@ngrx/store';

import { selectDisplayProceedButton } from '@modules/booking/store/proceed-button';

@Component({
  selector: 'pub-proceed-button',
  templateUrl: './proceed-button.component.html',
  styleUrls: ['./proceed-button.component.scss'],
})
export class ProceedButtonComponent {
  displayProceedButton$ = this.store.select(selectDisplayProceedButton);

  constructor(public proceedService: ProceedService, private store: Store) {}
}
